import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import styles from "assets/jss/material-dashboard-pro-react/components/typographyStyle.js";

const useStyles = makeStyles(styles);

export default function Code(props) {
  const classes = useStyles();
  const { children } = props;
  return (
    <span className={classes.defaultFontStyle + " " + classes.codeText}>
      {children}
    </span>
  );
}

Code.propTypes = {
  children: PropTypes.node
};
